// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ry","text":"rz","subText":"rA","toggleContainer":"rB","checked":"rC"};